export const DEFAULT_BRANDING = {
  primary: "#0A0A0A",
  secondary: "#334155",
  accent: "#4F46E5",
};

export function safeForeground(hex) {
  const value = /^#[0-9a-f]{6}$/i.test(hex || "") ? hex.slice(1) : "000000";
  const channels = [0, 2, 4]
    .map((offset) => parseInt(value.slice(offset, offset + 2), 16) / 255)
    .map((channel) => channel <= 0.03928 ? channel / 12.92 : ((channel + 0.055) / 1.055) ** 2.4);
  return 0.2126 * channels[0] + 0.7152 * channels[1] + 0.0722 * channels[2] > 0.45 ? "#0f172a" : "#ffffff";
}

export function brandingVariables(settings = {}) {
  const primary = settings.brand_primary || DEFAULT_BRANDING.primary;
  const secondary = settings.brand_secondary || DEFAULT_BRANDING.secondary;
  const accent = settings.brand_accent || DEFAULT_BRANDING.accent;
  return { "--brand-primary": primary, "--brand-primary-foreground": safeForeground(primary), "--brand-secondary": secondary, "--brand-accent": accent, "--brand-accent-foreground": safeForeground(accent) };
}

export function applyBranding(settings, root = document.documentElement) {
  Object.entries(brandingVariables(settings)).forEach(([key, value]) => root.style.setProperty(key, value));
}
